import type { BannerType } from '@sravni/react-advertisement/lib/types';

import type { TBannersList } from '../../types/advertising';
import { getBannersFromStateSelector, getIsLoadingBannerFromStateSelector } from '../selectors/advertising';

import { useAppSelector } from './redux';

export const useBanners = (): TBannersList => useAppSelector(getBannersFromStateSelector);

export const useIsLoadingBanner = (type: BannerType): boolean =>
  useAppSelector(getIsLoadingBannerFromStateSelector(type));
